import { render, staticRenderFns } from "./BtnCancelarRequisicao.vue?vue&type=template&id=48e1a4f2&"
import script from "./BtnCancelarRequisicao.vue?vue&type=script&lang=js&"
export * from "./BtnCancelarRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports